<template>
  <div class="drawer">
    <el-drawer
      size="1000px"
      title="设置本月排班"
      :visible.sync="drawerStatus"
      @close="handleClose"
    >
      <div class="page">
        <div style="padding: 15px; background: #f5f5f5; text-align: center">
          所设月份:{{ transformTime(this.currDate) }}
        </div>
        <div
          style="padding: 15px; margin: 10px;
            display: flex;
            justify-content: space-between;
          "
        >
          <div>排班时间</div>
          <div style="color: #f5882a; cursor: pointer" @click="newAdd">
            +新建
          </div>
        </div>
        <el-table :data="tableData">
          <el-table-column label="排班日期">
            <template slot-scope="scope">
              <el-select
              style="width:80px"
                v-model="scope.row.beginDay"
                placeholder="开始"
              >
                <el-option
                  v-for="item in dataArr"
                  :key="item.id"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
              <el-select
              style="width:80px;margin-left: 5px;"
                v-model="scope.row.endDay"
                placeholder="结束"
              >
                <el-option
                  v-for="item in dataArr"
                  :disabled="item<=scope.row.beginDay"
                  :key="item.id"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="员工">
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.staffIds"
                multiple
                placeholder="请选择"
              >
                <el-option
                  multiple
                  v-for="item in staffInfoList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="排班分类">
            <template slot-scope="scope">
              <!-- 0不排班；1早班；2晚班；3通班；4休息； -->
              <el-select v-model="scope.row.timesId" placeholder="请选择">
                <el-option
                  v-for="item in [
                    { label: '早班', value: 1 },
                    { label: '晚班', value: 2 },
                    { label: '通班', value: 3 },
                    { label: '休息', value: 4 },
                  ]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="handleDelete(scope.$index, scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="height: 40px; width: 100%"></div>
      <div class="btnBox">
        <div class="btnItem" @click="drawerStatus = false">取消</div>
        <div class="btnItem submit" @click="submit">保存</div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      drawerStatus: false,
      direction: "rtl",
      tableData: [],
      staffInfoList: [
        {
          basic_info: {
            nick_name: "",
          },
          _id: "",
        },
      ],
      value1: [],
      value: "",
      currDate: sessionStorage.getItem("pBMonth") * 1000,
      dataList: [],
      item: [],
      dataArr: [],
    };
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.drawerStatus = true;
      
    });
    this.getStaffInfoList();
    this.getTime();
    
  },
  methods: {
  
    getTime() {
      let Timedate = new Date(
        new Date(this.currDate).getFullYear(),
        new Date(this.currDate).getMonth() + 1
      );
      Timedate.setDate(0);
      console.log(Timedate.getDate());
      for (var i = 1; i <= Timedate.getDate(); i++) {
        this.dataArr.push(i);
      }
      // return Timedate.getDate();
    },
    // 保存
    submit() {
      console.log('tableData',this.tableData);
      
      var d = new Date(this.currDate);
      let params = {
        shopId: this.$store.state.shopId,
        year: d.getFullYear(),
        month: d.getMonth() + 1,
        items: this.tableData,
      };
      console.log("params", params);

      this.$http
        .post(
          process.env.VUE_APP_AppAdmin + "/api/ShopSchedule/speedSchedule",
          params
        )
        .then((res) => {
          if (res.code == 0) {
            this.$emit("submit");
            console.log(res);
          }
        });
    },
    // 获取员工列表
    getStaffInfoList() {
      let loading = this.$loading();
      var d = new Date(this.currDate);
      this.$http
        .get(process.env.VUE_APP_AppAdmin + "/api/ShopSchedule/staffList", {
          shopId: this.$store.state.shopId,
          year: d.getFullYear(),
          month: d.getMonth() + 1,
        })
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            this.staffInfoList = res.data;
            // console.log("员工列表", res);
          }
        });
    },

    handleDelete(index) {
      this.tableData.splice(index, 1);
    },
    // 标准日转化为年月日
    transformTime(date) {
      var d = new Date(date);
      var datetime = d.getFullYear() + "-" + (d.getMonth() + 1);
      return datetime;
    },
    newAdd() {
      let obj = {};
      this.tableData.push(obj);
    },
    //   关闭弹框
    handleClose() {
      this.$emit("submit");
    },
  },
};
</script>

<style scoped lang="scss">
.page {
  font-size: 12px;
  padding: 20px;
  .btnBox {
    width: 100%;
    font-size: 14px;
    color: #fff;
    line-height: 40px;
    display: flex;
    position: absolute;
    bottom: 0;
    z-index: 10;
    .btnItem {
      text-align: center;
      width: 100%;
      background-color: #d6d6d6;
      cursor: pointer;
      &.submit {
        background-color: $mainColor;
      }
    }
  }
}
</style>